import { render, staticRenderFns } from "./renamed.vue?vue&type=template&id=68b87bce&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "renamed.vue"
export default component.exports